// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"0":"81f09a27","98":"ac3ddc3a","130":"d98b4e85","202":"5203cf16","406":"668f46cc","762":"212d9b70","832":"db316a97"}[chunkId] + ".chunk.js";
};